import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CENQtyMultiCheckoutErr from "@tCentro/Store/Reducer/CENQtyMultiCheckoutErr";
import { Draft } from "immer";

const initialState: CENQtyMultiCheckoutErr = {
    isMinErrorOrMultiError: false,
};

const reducer = {
    "Pages/CenQtyMultiCheckoutErrState": (
        draft: Draft<CENQtyMultiCheckoutErr>,
        action: {
            isMinErrorOrMultiError: boolean;
        },
    ) => {
        draft.isMinErrorOrMultiError = action.isMinErrorOrMultiError;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
